/* Publish by EComposer at 2026-11-04 05:45:41*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mch5erdhya8"]=  window.__ectimmers["ecom-mch5erdhya8"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-mch5erdhya8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-mch5erdhya8', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-mch5erdhya8', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-dmc01j6tli').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-dmc01j6tli', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-dmc01j6tli', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-lkqrx9q1my').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-lkqrx9q1my', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-lkqrx9q1my', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gj2xjuvwdcg').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gj2xjuvwdcg', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gj2xjuvwdcg', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-eof5nut402i').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-eof5nut402i', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-eof5nut402i', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-nn86ta1virm').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-nn86ta1virm', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-nn86ta1virm', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-k7pyp6ouvfl').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-k7pyp6ouvfl', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-k7pyp6ouvfl', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gw75cqsk235').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gw75cqsk235', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gw75cqsk235', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-e5sst70gub').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-e5sst70gub', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-e5sst70gub', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gm2547jtw97').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gm2547jtw97', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gm2547jtw97', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gm8zmgsynqe').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gm8zmgsynqe', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gm8zmgsynqe', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-7wg0kar48ea').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7wg0kar48ea', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7wg0kar48ea', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-zbjs0tdfdk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-zbjs0tdfdk', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-zbjs0tdfdk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-7dxht3muizi').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7dxht3muizi', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7dxht3muizi', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-59ldcdxtmk5').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-59ldcdxtmk5', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-59ldcdxtmk5', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qwxbrjj6cmr').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qwxbrjj6cmr', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qwxbrjj6cmr', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qbrnzqysxgc').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qbrnzqysxgc', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qbrnzqysxgc', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-tnwnc253ktj').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-tnwnc253ktj', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-tnwnc253ktj', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-79chlicowf2').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-79chlicowf2', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-79chlicowf2', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-dxqpog8fx1b').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-dxqpog8fx1b', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-dxqpog8fx1b', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9hvszliszv9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9hvszliszv9', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9hvszliszv9', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-kbaquudkev').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-kbaquudkev', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-kbaquudkev', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-xb5fmz4sb9c').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-xb5fmz4sb9c', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-xb5fmz4sb9c', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-4ehrzn73tpq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4ehrzn73tpq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4ehrzn73tpq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-i6q3vinb4re').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-i6q3vinb4re', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-i6q3vinb4re', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3etah1mitjo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3etah1mitjo', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3etah1mitjo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-rslu1tw8kp').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rslu1tw8kp', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rslu1tw8kp', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-acpyns8kg8m').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-acpyns8kg8m', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-acpyns8kg8m', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-agh3z87xkyo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-agh3z87xkyo', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-agh3z87xkyo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-29ewmfncxlf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-29ewmfncxlf', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-29ewmfncxlf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-kmt8abkl84e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-kmt8abkl84e', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-kmt8abkl84e', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-4qgjtj4qv1').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4qgjtj4qv1', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4qgjtj4qv1', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-vjdrkslddlr').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vjdrkslddlr', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vjdrkslddlr', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-zwxx6bxgdu').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-zwxx6bxgdu', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-zwxx6bxgdu', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-2lsyafz0f07').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-2lsyafz0f07', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-2lsyafz0f07', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-f1hzez8oeeo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-f1hzez8oeeo', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-f1hzez8oeeo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-0u92lhveun3q').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0u92lhveun3q', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0u92lhveun3q', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-pyjmat0b5vn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-pyjmat0b5vn', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-pyjmat0b5vn', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-v5fnvxa335').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-v5fnvxa335', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-v5fnvxa335', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ctyn7v6vbpg').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ctyn7v6vbpg', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ctyn7v6vbpg', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-fzxhb5d9s1s').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-fzxhb5d9s1s', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-fzxhb5d9s1s', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-5ybfyenr8o6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5ybfyenr8o6', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5ybfyenr8o6', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-2sd6g5zowts').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-2sd6g5zowts', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-2sd6g5zowts', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-fa6nhl7yi0b').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-fa6nhl7yi0b', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-fa6nhl7yi0b', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-get68ue3s5').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-get68ue3s5', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-get68ue3s5', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-n3lkf0eeny').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-n3lkf0eeny', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-n3lkf0eeny', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-v1704v46yjd').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-v1704v46yjd', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-v1704v46yjd', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qp5nyr23zmk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qp5nyr23zmk', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qp5nyr23zmk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ehf6hq0lli').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ehf6hq0lli', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ehf6hq0lli', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qg54tyep2be').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qg54tyep2be', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qg54tyep2be', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pyu86d2lh8h"]=  window.__ectimmers["ecom-pyu86d2lh8h"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-pyu86d2lh8h"]["eafhz1c3h"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-pyu86d2lh8h').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-pyu86d2lh8h', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-pyu86d2lh8h', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-a6mhlr7s5hw').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-a6mhlr7s5hw', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-a6mhlr7s5hw', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-q7rsyzy12o').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-q7rsyzy12o', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-q7rsyzy12o', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-5ze0owxasf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5ze0owxasf', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5ze0owxasf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-xvt4ghu3et9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-xvt4ghu3et9', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-xvt4ghu3et9', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3uxmpsu77e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3uxmpsu77e', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3uxmpsu77e', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-x2xe607jc7n').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-x2xe607jc7n', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-x2xe607jc7n', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gm7qc5m8nt').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gm7qc5m8nt', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gm7qc5m8nt', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3zfzedc8hu2"]=  window.__ectimmers["ecom-3zfzedc8hu2"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),n=this.settings.action;function o(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var p;(p=d.ec_splide)==null||p.refresh()})},50),r())}e.forEach((a,l)=>{n==="click"||window.screen.width<1025?a.onclick=()=>o(a,l):a.onmouseover=()=>o(a,l)});function s(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let m=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,m)}}}setTimeout(()=>{s()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-3zfzedc8hu2').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3zfzedc8hu2', settings: {"action":"click"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3zfzedc8hu2', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6auyf8uzobm"]=  window.__ectimmers["ecom-6auyf8uzobm"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,n=this.settings.autoplay,o=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const p=t.querySelector(".ecom-video-poster");let m;m=d&&d.querySelector(".ecom-video-icon-play");const _=t.querySelector(".ecom-element_video-iframe");o&&setTimeout(function(){b(_)},500);function b(I){let j={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,j).observe(I)}function y(I,j){let M={handleMouseenter:D,handleMouseleave:T,handleEnded:F};function D(){I.readyState>=c&&I.pause()}function T(){I.readyState>=c&&I.play()}function F(){v(I,M)}if(r){I.addEventListener("mouseenter",D),I.addEventListener("mouseleave",T);let H=t.querySelector(".ecom-video_link-extra");H&&H.href&&(H.addEventListener("mouseenter",D),H.addEventListener("mouseleave",T)),j||I.addEventListener("ended",F)}}function v(I,j){if(j){const{handleMouseenter:M,handleMouseleave:D,handleEnded:T}=j;let F=t.querySelector(".ecom-video_link-extra");I.removeEventListener("mouseenter",M),I.removeEventListener("mouseleave",D),I.removeEventListener("ended",T),F&&F.href&&(F.removeEventListener("mouseenter",M),F.removeEventListener("mouseleave",D))}}function w(I,j){I.forEach(function(M){if(M.isIntersecting){const D=M.target.querySelector("video source"),T=M.target.querySelector("video"),F=M.target.querySelector("iframe");if(T&&D&&(D.src=D.dataset.source,T.load(),T.addEventListener("loadeddata",function(){n&&T.play()})),F){let H=F.dataset.srcVideo;F.setAttribute("src",H)}j.unobserve(M.target)}})}let S=t.querySelector(".ecom_video"),C=t.querySelector(".ecom_iframe");a&&S&&S.addEventListener("click",()=>{S.readyState>=c&&(S.paused?S.play():S.pause())}),n&&(d&&d.classList.remove("ecom-overlay"),m&&(m.style.display="none"),p&&(p.style.display="none")),S&&!i&&S.addEventListener("ended",function(){p&&(p.style.display="block"),d&&d.classList.add("ecom-overlay"),m&&(m.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&S)p&&(p.style.display="none"),S.autoplay=!0,S.play(),d.classList.remove("ecom-overlay"),m.style.display="none";else if(C){let I=C.getAttribute("src");I.includes("autoplay=0")?I=I.replace("autoplay=0","autoplay=1"):I=I+"&autoplay=1",C.setAttribute("src",I),l?setTimeout(()=>{I=I.replace("autoplay=1","autoplay=0"),C.setAttribute("src",I)},100):(p&&(p.style.display="none"),d.classList.remove("ecom-overlay"),m.style.display="none")}}),S&&(e&&!p&&y(S,i),p&&p.addEventListener("click",function(){p.style.display="none",S.play(),e&&y(S,i)}),r||S.addEventListener("pause",function(){p&&(p.style.display="block"),d&&d.classList.add("ecom-overlay"),m&&(m.style.display="block")}),!s&&d&&S.addEventListener("click",function(){S.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function(I){I.dataset.ecTrackingId&&I.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:I.id,tracking_id:I.dataset.ecTrackingId})},{once:!0})});const x=t.querySelector("[ecom-modal]"),$=function(I){if(window.EComModal)return I();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&I()});return}let j=0;const M= window.__ectimmers["ecom-6auyf8uzobm"]["qnq49i696"] = setInterval(function(){window.EComModal?(clearInterval(M),I()):++j>=300&&clearInterval(M)},50)},E=this.id;x&&this.settings.image_overlay&&l&&$(function(){const I=x.dataset.width,j=x.dataset.height;var M=E;new window.EComModal(x,{cssClass:[M,"ecom-core","ecom-core-simulator"],onOpen:function(){var D=document.querySelector(".ecom-modal."+M);if(D){const T=D.querySelector(".ecom-modal-box__content");T.classList.add("ecom-element_video-iframe");const F={width:I,height:j};Object.assign(T.style,F)}},onClose:function(){var D=document.querySelector(".ecom-modal."+M);if(D){const T=D.querySelector(".ecom-element_video-iframe iframe");T&&(T.src="")}}})})

                    });
                    
                        document.querySelectorAll('.ecom-6auyf8uzobm').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6auyf8uzobm', settings: {"loop":true,"autoplay":true,"player_controls":false,"source":"uploaded"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6auyf8uzobm', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-jytkxadzmj8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-jytkxadzmj8', settings: {"autoplay":true,"player_controls":true,"source":"uploaded"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-jytkxadzmj8', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ux4vyh1l94k"]=  window.__ectimmers["ecom-ux4vyh1l94k"] || {};
if(!this.$el)return;const e=this.$el,i=this,t=this.settings.layout;let s=e.closest(".core__row--columns");const l=e.querySelector(".ecom-shopify__menu-list--mobile"),c=e.querySelector(".ecom-menu__icon-humber"),r=e.querySelector(".ecom-menu-collapse-close--mobile");let m=e.closest("div.ecom-core.core__block")||"",u=e.closest("div.ecom-column.ecom-core")||"",d=e.querySelectorAll(".ecom-shopify__menu-item--link");for(m&&(m.style.overflow="visible"),d&&l&&d.forEach(function(n){n.addEventListener("click",function(){g()})}),c&&(c.addEventListener("click",v),r.addEventListener("click",g));s;)s.style.zIndex="100",s=s.parentElement.closest(".core__row--columns");function v(){!l||(l.parentNode.style.display="block",l.classList.add("ecom-show"),m&&(m.style.zIndex="100"),u&&(u.style.zIndex="100"),document.querySelector("body").classList.add("ecom-menu-opened"),setTimeout(function(){document.addEventListener("click",f),document.addEventListener("keydown",y)},500))}function f(n){let _=n.target;do{if(_==l)return;_=_.parentNode}while(_);_!=l&&(g(),document.removeEventListener("click",f),document.removeEventListener("keydown",y))}function y(n){(n.isComposing||n.keyCode===27)&&(g(),document.removeEventListener("keydown",y),document.removeEventListener("click",f))}function g(){l.parentNode.style.display="none",l.classList.remove("ecom-show"),e.querySelectorAll("ecom-menu_item.ecom-item-active").forEach(function(n){n.classList.remove("ecom-item-active")}),m&&(m.style.zIndex="1"),u&&(u.style.zIndex="1"),document.querySelector("body").classList.remove("ecom-menu-opened"),document.removeEventListener("keydown",y),document.removeEventListener("click",f)}let $=e.querySelector('.ecom-shopify__menu-list[data-menu-layout="horizontal"]'),k=null;$&&(k=$.querySelectorAll(".ecom-shopify__menu-item--has-children>.ecom-menu_item>.ecom-element--menu_title")),k&&k.forEach(function(n){n.addEventListener("click",function(_){_.preventDefault()})});function A(){var n=e.querySelectorAll(".ecom-shopify__menu-list .ecom-shopify__menu-item--has-children > .ecom-menu_item, .ecom-shopify__menu-list .ecom-shopify__menu-child-link-item--has-children > .ecom-menu_item"),_=e.querySelectorAll(".ecom-shopify__menu-list--mobile .ecom-shopify__menu-item--has-children > .ecom-menu_item, .ecom-shopify__menu-list--mobile .ecom-shopify__menu-child-link-item--has-children > .ecom-menu_item");if(!!n){var a,w="false",x=e.querySelector(".ecom-shopify__menu-wrapper");if(x&&x.dataset.showAll)var w=x.dataset.showAll;for(a=0;a<n.length;a++){let b=function(o){let h=o.nextElementSibling,p=null;if(o.classList.contains("ecom-item-active")){if(o.classList.remove("ecom-item-active"),h){h.style.maxHeight=null;var z=h.querySelectorAll(".ecom-menu_item");z&&z.forEach(L=>{var C=L.nextElementSibling;C&&(C.style.maxHeight=null),L.classList.remove("ecom-item-active")}),p=o.closest(".ecom-shopify__menu-sub-menu"),p&&(p.style.maxHeight=parseInt(p.style.maxHeight)-h.scrollHeight+"px")}}else o.classList.add("ecom-item-active"),h&&(p=o.closest(".ecom-shopify__menu-sub-menu"),p&&(p.style.maxHeight=parseInt(p.style.maxHeight)+h.scrollHeight+"px"),h.style.maxHeight=h.scrollHeight+"px")};if(t==="horizontal"&&!i.isLive)n[a].addEventListener("click",function(o){o.preventDefault()});else if(t==="horizontal"&&i.isLive)n[a].addEventListener("click",function(o){o.stopPropagation()});else if((t==="vertical"||!i.isLive)&&(w&&w=="true"&&b(n[a]),n[a].addEventListener("click",function(o){i.settings.toggle_submenu_on_arrow||(o.preventDefault(),b(this))}),i.settings.toggle_submenu_on_arrow)){let o=n[a].querySelector(".ecom-element--menu_icon");if(o){let h=n[a];o.addEventListener("click",function(p){p.preventDefault(),b(h)})}}_[a]&&_[a].addEventListener("click",function(o){o.preventDefault(),b(this)})}}}A()

                    });
                    
                        document.querySelectorAll('.ecom-ux4vyh1l94k').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ux4vyh1l94k', settings: {"layout":"horizontal"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ux4vyh1l94k', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rhsxpoyg8lo"]=  window.__ectimmers["ecom-rhsxpoyg8lo"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-rhsxpoyg8lo"]["c0j977k4g"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-rhsxpoyg8lo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rhsxpoyg8lo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rhsxpoyg8lo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9r6eeepoxd5').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9r6eeepoxd5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9r6eeepoxd5', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-yx4x555qgn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-yx4x555qgn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-yx4x555qgn', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-hle012wik9o').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-hle012wik9o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-hle012wik9o', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-vhkxazjhoka').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vhkxazjhoka', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vhkxazjhoka', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-kwavedwepxl').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-kwavedwepxl', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-kwavedwepxl', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-h5rmwods32a').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-h5rmwods32a', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-h5rmwods32a', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-fvtykd45ppc').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-fvtykd45ppc', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-fvtykd45ppc', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-nl1a87zma1e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-nl1a87zma1e', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-nl1a87zma1e', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-d3q085vaiyq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-d3q085vaiyq', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-d3q085vaiyq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-7nfdxzb7p1k').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7nfdxzb7p1k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7nfdxzb7p1k', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-yn6rcjly2l').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-yn6rcjly2l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-yn6rcjly2l', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-14q7sph33fx').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-14q7sph33fx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-14q7sph33fx', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-0t5vfknfn0zf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0t5vfknfn0zf', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0t5vfknfn0zf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-g5jdj6rwgkv').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-g5jdj6rwgkv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-g5jdj6rwgkv', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}